export default "__VITE_ASSET__06875476__"